import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import l10n from "../../../l10n/localization";
import * as utils from "../../../utils/country";

class SelectCountries extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {

        return (
            <div className="form-group field">
                <label className="control-label" htmlFor="root_country">
                    {l10n.common.country}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_country"
                    value={this.props.formData}
                    options={utils.countryToSelect(this.props.countries)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        countries: state.country.countries,
        loading: state.country.loading,
    });
})(SelectCountries);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectCountries.js